import * as React from "react";
import ClockInOutFooter from "./ClockInOutFooter";

interface Props {
  canClockIn: boolean;
  canClockOut: boolean;
  canSubmitTimesheet: boolean;
  onClockIn: () => void;
  onClockOut: () => void;
  onSubmitTimesheet: () => void;
}

const PatientTaskInstanceScreenFooter = (props: Props) => {
  return (
    <ClockInOutFooter
      canClockIn={props.canClockIn}
      canClockOut={props.canClockOut}
      canSubmitTimesheet={props.canSubmitTimesheet}
      clockInDateTime={null}
      clockOutDateTime={null}
      onClockIn={props.onClockIn}
      onClockOut={props.onClockOut}
      onSubmitTimesheet={props.onSubmitTimesheet}
    />
  );
};

export default PatientTaskInstanceScreenFooter;
